import { OnFetchBonus, OnFetchBonusError } from "./bonus-events";
import { createAction } from "@cobuildlab/react-simple-state";
import { fetchBonus } from "./bonus-services";

export const fetchBonusAction = createAction(
  OnFetchBonus,
  OnFetchBonusError,
  fetchBonus
);
